module.exports = __webpack_public_path__ + "img/lg_ring_g_l_1_null@3x.1828b458.png";